export const Constants = {
  Storage: {
    UserAccountName: 'user_account_name'
  }
};
